import { IMAGES } from "@/config";
import { SESSION } from "@/config/session";
import { Reveal, CtaButton, ImageSlot } from "./Primitives";
import { Countdown } from "./Countdown";

export const FinalCta = () => (
  <section className="px-4 pb-14 sm:pb-20 bg-white" data-testid="final-cta-section">
    <Reveal className="max-w-5xl mx-auto rounded-3xl final-bg overflow-hidden p-5 sm:p-10 grid md:grid-cols-[0.8fr_1.2fr] gap-6 md:gap-10 items-center">
      <div className="aspect-square max-w-[300px] w-full mx-auto rounded-2xl overflow-hidden">
        <ImageSlot dark src={IMAGES.final || IMAGES.hero} label="Sandeep Gupta photo (square)" alt="Sandeep Gupta" position="center 20%" testId="final-image-slot" />
      </div>
      <div className="text-white">
        <span className="inline-block rounded bg-plum text-white text-[12px] font-extrabold uppercase tracking-wider px-3 py-1">FREE MASTERCLASS</span>
        <h2 className="font-extrabold text-[23px] sm:text-[32px] leading-tight mt-3">Spots Are Filling Out Fast… Secure Your Seat Now!</h2>
        <p className="text-white/80 text-sm sm:text-base mt-2">Join The Wealth Code Masterclass This {SESSION.dayLabel}!</p>
        <div className="mt-5 space-y-4 max-w-md">
          <CtaButton testId="final-cta-button" />
          <p className="flex items-baseline gap-2 text-lg" data-testid="final-price">
            <span className="font-black text-green-400 text-2xl">FREE</span>
            <span className="line-through text-white/70">₹999</span>
          </p>
          <Countdown dark testId="final-countdown" />
        </div>
      </div>
    </Reveal>
  </section>
);

export const Footer = ({ className = "pb-28 md:pb-10" }) => (
  <footer className={`bg-[#F7F4FC] px-4 pt-8 text-center ${className}`} data-testid="footer">
    <div className="max-w-3xl mx-auto space-y-3 text-[12px] text-zinc-600 leading-relaxed">
      <p>This masterclass is for educational purposes only and is not investment advice. Investments are subject to market risks; read all related documents carefully.</p>
      <p>This site is not a part of the Facebook website or Meta Platforms, Inc., and is not endorsed by Facebook in any way.</p>
      <p className="font-semibold text-ink">© 2026 Wealth Accelerator Hub</p>
    </div>
  </footer>
);
